import React from 'react';

/** The 24 px line icon of the script rows. */
const LineIcon: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.8}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    {children}
  </svg>
);

/** The pen of "Edit" (design e1 `.ib`). */
export const EditIcon: React.FC = () => (
  <LineIcon>
    <path d="M4 20h4l10-10-4-4L4 16z" />
  </LineIcon>
);

/** The sparkle of "Rewrite". */
export const SparkleIcon: React.FC = () => (
  <LineIcon>
    <path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z" />
  </LineIcon>
);

/** The bin of "Remove". */
export const RemoveIcon: React.FC = () => (
  <LineIcon>
    <path d="M5 7h14M10 7V4h4v3M7 7l1 13h8l1-13" />
  </LineIcon>
);

/** The dots of the row menu on a phone (design j3). */
export const MoreIcon: React.FC = () => (
  <LineIcon>
    <circle cx="5" cy="12" r="1" />
    <circle cx="12" cy="12" r="1" />
    <circle cx="19" cy="12" r="1" />
  </LineIcon>
);
